const selectCommunicationCategoryOptions = [
  { id: 1, name: 'Aniversário', config: true },
  //{ id: 2, name: 'Cadastro atendimento', config: false },
  //{ id: 3, name: 'Atualização atendimento', config: false },
  { id: 4, name: 'Cadastro eleitor', config: false },
  { id: 5, name: 'Atualização cadastral de eleitor', config: false },
  { id: 6, name: 'Visita ao escritório', config: false }
];

export default selectCommunicationCategoryOptions;
